// pages/Contact.js
import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ServiceMenuContact from '../components/ServiceMenuContact';
import styles from './Contact.module.css';

// Komponenta za Kontakt informacije
const KontaktInformacije = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.contentContainer}>
        <div className={styles.contactGrid}>
          <div className={styles.contactCard}>
            <h2>Adresa</h2>
            <p>Jug Bogdana 18<br />Banja Luka, 78000</p>
          </div>
          
          <div className={styles.contactCard}>
            <h2>Email</h2>
            <p>
              <a href="mailto:info@jovicadvisory.com" className={styles.contactLink}>
                info@jovicadvisory.com
              </a>
            </p>
          </div>
          
          <div className={styles.contactCard}>
            <h2>Telefon</h2>
            <p>
              <a href="tel:+38765123456" className={styles.contactLink}>
                +387 65 123 456
              </a>
            </p>
          </div>
          
          <div className={styles.contactCard}>
            <h2>Radno vrijeme</h2>
            <p>Ponedjeljak - Petak<br />09:00 - 17:00</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Komponenta za Zakazivanje konsultacija
const ZakaziKonsultacije = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.contentContainer}>
        <div className={styles.consultationBox}>
          <h2>Zakažite konsultacije</h2>
          <p className={styles.consultationDescription}>
            Ispunite formu i javićemo vam se u najkraćem roku.
          </p>
          
          <form className={styles.consultationForm}>
            <div className={styles.formGroup}>
              <input
                type="text"
                placeholder="Ime i prezime"
                className={styles.formInput}
              />
            </div>
            
            <div className={styles.formGroup}>
              <input
                type="email"
                placeholder="Email adresa"
                className={styles.formInput}
              />
            </div>
            
            <div className={styles.formGroup}>
              <input
                type="tel"
                placeholder="Telefon"
                className={styles.formInput}
              />
            </div>
            
            <div className={styles.formGroup}>
              <textarea
                placeholder="Kratak opis vašeg upita"
                rows="4"
                className={styles.formTextarea}
              />
            </div>
            
            <button type="submit" className={styles.submitButton}>
              Pošalji zahtjev
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

// Glavna Contact komponenta
const Contact = () => {
  return (
    <div className={styles.wrapper}>
      {/* Placeholder za fixed header */}
      <div className={styles.headerPlaceholder} />
      
      {/* Prvi sloj - Naslov */}
      <div className={styles.titleLayer}>
        <div className={styles.contentContainer}>
          <h1 className={styles.pageTitle}>Kontakt</h1>
        </div>
      </div>
      
      {/* Drugi sloj - Podmeni */}
      <ServiceMenuContact />
      
      {/* Treći sloj - Sadržaj */}
      <Routes>
        <Route path="/" element={<KontaktInformacije />} />
        <Route path="zakazivanje" element={<ZakaziKonsultacije />} />
      </Routes>
    </div>
  );
};

export default Contact;